// Shared by the drop page's card grids (dares, creators), which all run the same
// `grid-cols-1 / sm:grid-cols-2 / lg:grid-cols-3` layout. Kept in one place so "N rows" resolves to the
// right item count at every breakpoint and cannot drift from the grid classes in a single section.
export const columnsForWidth = (width) => {
    if (width >= 1024)
        return 3;
    if (width >= 640)
        return 2;
    return 1;
};
